import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    minHeight: 500,
    maxHeight: '80vh'
  },
  modalHeader: {
    marginBottom: theme.spacing(6)
  },
  modalContent: {
    marginBottom: theme.spacing(2),
    lineHeight: 1.5
  },
  content: {
    maxHeight: 'calc(80vh - 200px)',
    overflowY: 'auto'
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: theme.spacing(4),
    marginTop: theme.spacing(4)
  },
  previewImagesButton: {
    fontSize: 14,
    fontWeight: 600,
    padding: 0
  },
  previewImagesIcon: {
    marginLeft: theme.spacing(2)
  }
}));

export default useStyles;
